import React from 'react';

import Icon from './Icon';

export const ReloadIcon: React.FC = () => <Icon type="reload" />;
export const FindIcon: React.FC = () => <Icon type="find" />;
export const DeleteIcon: React.FC = () => <Icon type="delete" />;
export const EditIcon: React.FC = () => <Icon type="edit" />;
export const CancelIcon: React.FC = () => <Icon type="cancel" />;
export const CopyIcon: React.FC = () => <Icon type="copy" />;

export const MenuIcon: React.FC = () => <Icon type="menu" />;
export const SettingsIcon: React.FC = () => <Icon type="settings" />;

export const RightArrowIcon: React.FC = () => <Icon type="arrow-right" />;
export const DownArrowIcon: React.FC = () => <Icon type="arrow-down" />;

export const TokensIcon: React.FC = () => <Icon type="tokens" />;
export const RequestersIcon: React.FC = () => <Icon type="requesters" />;

export const WarningIcon: React.FC = () => <Icon type="warning" />;
export const InfoIcon: React.FC = () => <Icon type="info" />;

interface ActionIconProps
{
  action: () => void,
  tip?: string,
  disabled?: boolean,
  className?: string,
}
export const ActionIcon: React.FC<ActionIconProps> = ({action, tip, disabled, className, children}) =>
  <div title={tip} className={['icon actioned', disabled ? 'disabled' : '', className ? className : ''].join(' ')} onClick={disabled ? undefined : action}>{children}</div>;

interface LabeledIconProps
{
  label: string,
}
export const LabeledIcon: React.FC<LabeledIconProps> = ({label, children}) => <div className="icon labeled">{children}<span className="label">{label}</span></div>;

interface SelectedPageIconProps
{
  number: number,
}
export const SelectedPageIcon: React.FC<SelectedPageIconProps> = ({number}) => <Icon type="page">{number + 1}</Icon>;
interface PageIconProps extends SelectedPageIconProps
{
  action: (page: number) => void,
}
export const PageIcon: React.FC<PageIconProps> = ({number, action}) => <ActionIcon action={() => action(number)}><Icon type="page">{number + 1}</Icon></ActionIcon>;